import React from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";
import tableProps from "./types";

export function TableWide(props: tableProps) {
  return (
    <TableContainer component={Paper}>
      <Table aria-label="customized table">
        <TableHead>
          <TableRow>
            {props.columns.map((_) => (
              <TableCell
                align="left"
                key={_.id}
                style={{
                  width: _.width ? _.width : `initial`,
                  fontWeight: `bold`,
                  fontSize: `18px`,
                  fontFamily: `Noto Sans`,
                }}
              >
                {_.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {props.data.map((_, index) => props.Rows(_, index))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
